import React, { useState, useEffect } from 'react'
import FloatingLabelTextArea from './TextArea'
import InputBox from './InputBox'
import './WebsiteSetting.css'
import Dropdown from './Dropdown'
import CheckOutAndGeneralSetting from '../API/APIServices/CheckoutAndGeneralSetting'
import Loader from '../Inventory/Props/Loader'

const WebsiteSetting = () => {


    const [loading, setLoading] = useState(false);
    const [inputValues, setInputValues] = useState({
        companyTitle: '',
        title: '',
        description: '',
        keywords: '',
        companyWebsite: '',
        headerScript: '',
        headerDescription: '',
        footerDescription: '',
        mobileTitleIcon: '',
        allowStaticFooter: '',
        allowPOSStore: '',
    });

    async function fetchWebsiteSetting(){

        setLoading(true);

        let data = await CheckOutAndGeneralSetting.GetWebsiteSetting();

        console.log(data)
        if(data && data.isSuccess){
            let temp = {
                companyTitle: data.result?.companyTitle ? data.result?.companyTitle : '',
                title: data.result?.title ? data.result?.title : '',
                description: data.result?.description ? data.result?.description : '',
                keywords: data.result?.keywords ? data.result?.keywords : '',
                companyWebsite: data.result?.companyWebsite ? data.result?.companyWebsite : '',
                headerScript: data.result?.headerScript ? JSON.parse(data.result?.headerScript) : '',
                headerDescription: data.result?.headerDescription ? data.result?.headerDescription : '',
                footerDescription: data.result?.footerDescription ? JSON.parse(data.result?.footerDescription) : '',
                mobileTitleIcon: data.result?.mobileTitleIcon ? data.result?.mobileTitleIcon : '',
                allowStaticFooter: data.result?.allowStaticFooter ? data.result?.allowStaticFooter : '',
                allowPOSStore: data.result?.allowPOSStore ? data.result?.allowPOSStore : '',
            }

            setInputValues(temp);
        }
        setLoading(false);
    }

    useEffect(()=>{
        fetchWebsiteSetting();
    },[]);

    async function save(){

        setLoading(true);

        console.log("inputValues")
        console.log(inputValues)

        let dataToSend = {...inputValues};
        dataToSend.headerScript = JSON.stringify(inputValues.headerScript);
        dataToSend.footerDescription = JSON.stringify(inputValues.footerDescription);

        console.log("dataToSend")
        console.log(dataToSend)
        let data = await CheckOutAndGeneralSetting.CreateWebsiteSetting(dataToSend);

        if(data){

            if(data.isSuccess){
                alert("Data saved successfully!");
            }else{
                alert("An error occurred. Please try again.")
            }

        }

        fetchWebsiteSetting();
        setLoading(false);
    } 

    const Booloptions = [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
    ];

    const options = [
        { label: "Title", value: 0 },
        { label: "Icon", value: 1 }
    ]

    console.log(inputValues)

    return (
        <div>
            <div className='heading-setting'>Website Setting</div>
            <div className='grid-container'>
                <div className='grid-item-container'>
                    <InputBox label={"Company Title"}
                        name="companyTitle"
                        value={inputValues.companyTitle}
                        onChange={(newValue) => setInputValues({ ...inputValues, companyTitle: newValue })} />
                </div>
                <div className='grid-item-container'>
                    <InputBox label={"Title"}
                        name="title"
                        value={inputValues.title}
                        onChange={(newValue) => setInputValues({ ...inputValues, title: newValue })} />
                </div>
                <div className='grid-item-container'>
                    <FloatingLabelTextArea label={"Description"}
                        name="description"
                        value={inputValues.description}
                        onChange={(newValue) => setInputValues({ ...inputValues, description: newValue })} />
                </div>
                <div className='grid-item-container'>
                    <InputBox label={"Keywords"}
                        name="keywords"
                        value={inputValues.keywords}
                        onChange={(newValue) => setInputValues({ ...inputValues, keywords: newValue })} />
                </div>
                <div className='grid-item-container'>
                    <InputBox label={"Company Website"}
                        name="companyWebsite"
                        value={inputValues.companyWebsite}
                        onChange={(newValue) => setInputValues({ ...inputValues, companyWebsite: newValue })} />
                </div>
                <div className='grid-item-container'>
                    <FloatingLabelTextArea label={"Header Script"}
                        name="headerScript"
                        value={inputValues.headerScript}
                        onChange={(newValue) => setInputValues({ ...inputValues, headerScript: newValue })} />
                </div>
                <div className='grid-item-container'>
                    <FloatingLabelTextArea label={"Header Description"}
                        name="headerDescription"
                        value={inputValues.headerDescription}
                        onChange={(newValue) => setInputValues({ ...inputValues, headerDescription: newValue })} />
                </div>
                <div className='grid-item-container'>
                    <FloatingLabelTextArea label={"Body Script"}
                        name="footerDescription"
                        value={inputValues.footerDescription}
                        onChange={(newValue) => setInputValues({ ...inputValues, footerDescription: newValue })} />
                </div>
                <div className='grid-item-container'>

                    <Dropdown label={"Mobile Title/Icon"}
                        options={options}
                        selectedValue={inputValues.mobileTitleIcon}
                        onChange={(newValue) => setInputValues({ ...inputValues, mobileTitleIcon: newValue })} />
                </div>
                <div className='grid-item-container'>
                    <Dropdown
                        label={"Allow Static Footer"}
                        options={Booloptions}
                        selectedValue={inputValues.allowStaticFooter}
                        onChange={(newValue) => setInputValues({ ...inputValues, allowStaticFooter: newValue })}
                    />
                </div>
                <div className='grid-item-container'>
                    <Dropdown
                        label={"Allow POS Store"}
                        options={Booloptions}
                        selectedValue={inputValues.allowPOSStore}
                        onChange={(newValue) => setInputValues({ ...inputValues, allowPOSStore: newValue })}
                    />
                </div>
                <div style={{gap: "30px"}} className='grid-item-container button-container'>
                    <button onClick={save} className='submit-button'>Submit</button>
                </div>
            </div>
            {loading && <Loader />}
        </div>
    )
}

export default WebsiteSetting
